import { Component, type ReactNode } from "react"
import { reportClientError } from "@/lib/client-error-reporter"

// Root boundary: an uncaught render error would otherwise unmount the whole
// app and leave a blank white page. Fallback uses no providers or lazy code.
export class AppErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true }
  }

  componentDidCatch(error: Error): void {
    console.error("[AppErrorBoundary] render error:", error)
    reportClientError("boundary", error)
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-4 text-center">
          <p className="text-base">SmartExtract couldn’t display this page</p>
          <button
            type="button"
            className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
